//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { subscribeToQuery } from 'datocms-listen'
import { computed } from '~/mixins/pdpComponentMixin'
import createQuery from '~/gql/pdp.gql'

export default {
  mixins: [{ computed }],
  data () {
    return {
      design: {},
      secondaryDesign: {},
      customiserMode: false,
      showLensGuide: false,
      conversionKitEnabled: false,
      showIrisPreview: false,
      previousChoices: {},
      lensTechSelected: false,
      showLensTechWarning: false
    }
  },
  async fetch () {
    const { store, error, $redirect } = this.$nuxt.context

    // Redirect from revolts to snipers
    if ((this.$route.path === '/shop/goggles/revolts' || this.skuPrefix === 'revolts') && !this.sku.includes('-le_')) {
      return $redirect(`/shop/goggles/snipers?id=${(this.$route.query.id || '').replace('revolts-', 'snipers-').replace(/-r/g, '-sn')}`)
    }

    const gqlQuery = createQuery(this.skuPrefix)
    const preview = process.client && this.$route.query.preview

    const result = await this.$contentAPI.fetch({ query: gqlQuery, preview })
    if (!result || !result.baseProduct) {
      const errorsToLog = result.errors || 'Error fetching page'
      this.$sentry.captureException(errorsToLog)
      console.error(errorsToLog)
      return error({ statusCode: 404, message: `Unable to load ${this.skuPrefix}` })
    }

    store.commit('product/STORE_PAGE_CONFIG', { skuPrefix: this.skuPrefix, query: gqlQuery, result: result.baseProduct })

    try {
      await Promise.all([
        store.dispatch('review/GET_PRODUCT_REVIEWS', { baseSKU: this.baseSku, page: 1, quiet: true, generic: this.baseSKU === 'snipers' })
      ])
    } catch (e) {
      this.$sentry.captureException(e)
      error({
        statusCode: 503,
        message: 'Unable to load product details'
      })
    }
  },
  fetchDelay: 0,
  head () {
    return {
      title: this.getTitle(this.plainTextProductName),
      meta: [
        ...this.getDescription(this.description),
        { hid: 'og:title', property: 'og:title', content: this.getTitle(this.plainTextProductName) },
        { hid: 'og:image', property: 'og:image', content: `https://dynamic.sungod.co/herodynamic/${this.sku}.800.0.png` }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getRouteForSKU: 'url/routeForSku'
    })
  },
  watch: {
    sku (sku) {
      this.updateURL()
      this.trackSKUChange()
    },
    secondarySku (sku) {
      this.updateURL()
    },
    customiserMode (customiserMode) {
      this.$store.dispatch('session/TRACK', { event: customiserMode ? 'PP_SHOW_CUSTOMISE' : 'PP_HIDE_CUSTOMISE', sku: this.sku })
    }
  },
  created () {
    this.initPage()
  },
  async mounted () {
    this.initPage()
    
    this.trackSKUChange = this.debounce(this.trackSKUChange, 1000)
    this.trackItemView()

    if (this.$route.query.scroll_to_video) {
      this.$scrollTo('.product-video-cont')
    } else if (this.$route.query.scroll_to_preview) {
      this.$scrollTo('.lens-details-block-cont')
    } else if (this.$route.query.scroll_to) {
      this.$scrollTo(`#${this.$route.query.scroll_to}`)
    }

    this.$store.dispatch('session/TRACK', { event: 'PP_INIT', sku: this.sku })

    this.$track.ecommerce.viewProductPage([{ sku: this.sku }])

    if (this.$route.query.preview) {
      this.unsubscribe = await subscribeToQuery({
        token: this.$config.datoApiToken,
        query: this.gqlQuery,
        preview: true,
        onChannelError: this.onChannelError,
        onUpdate: this.onUpdate
      })
    }
  },
  methods: {
    initPage () {
      if (!this.leMode) {
        this.design = this.getEntryChoices(this.skuPrefix)
      
        this.secondaryDesign = this.getSecondaryEntryChoices(this.skuPrefix, this.design)
        this.conversionKitEnabled = Object.keys(this.secondaryDesign).length > 0
        if (['velans', 'vulcans', 'airas'].includes(this.baseSku) && (!this.conversionKitEnabled || this.pageMode === 'conversionkit')) this.setSecondaryDesign()

        this.previousChoices = { ...this.secondaryDesign, ...this.design }

        this.lensTechSelected = !!this.$route.query.rlt

        if (this.pageMode !== 'custom') this.customiserMode = true
      }
    },
    setSku (sku) {
      this.$store.dispatch('session/TRACK', { event: 'PP_SELECT_BESTSELLER', sku })
      
      if ((this.leMode && sku !== this.sku) || (!this.leMode && sku.includes('-le_'))) {
        // Try to get a known route first
        const route = this.getRouteForSKU(sku)
        if (route) return this.$router.push({ path: this.localePath(route) })

        // Failover to using the redirect route
        return this.$router.push({ path: this.localePath('/shop/redirect'), query: { sku } })
      }

      // Alter SKU to match current lens tech
      if (this.allowLensTechFiltering) sku = this.getSKUWithLensTech(sku, this.lensTech)

      const newDesign = Object.fromEntries(sku.split('-').slice(1).map(skuPart => skuPart.split('_')))
      Object.entries(newDesign).forEach(([part, choice]) => {
        // Handle swappable parts by identifying which part is currently in use
        if (part === 'swappable') {
          const swappableChoice = this.swappableParts.find(part => part in this.design)
          if (swappableChoice) {
            part = swappableChoice

            // Nose piece must always match frame in custom mode
            if (this.pageMode === 'custom') {
              if (part === 'vcn') choice = newDesign.vcf || this.design.vcf || null
              if (part === 'ven') choice = newDesign.vef || this.design.vef || null
            }
          } else return // Shouldn't be possible but don't throw an error
        }

        // Also shouldn't be possible
        if (!choice || !part) return

        if (this.design[part] !== choice) this.changeDesign(part, choice)
      })
    },
    changeDesign (part, choice, secondary = null) {
      if (choice === 'none') return
      
      this.previousChoices = { ...this.previousChoices, [part]: choice }

      // Determine if this is a secondary choice
      if (secondary === null) secondary = !(part in this.design)

      // In parts mode then completely change the design
      if (this.pageMode === 'parts') {
        this.design = { [part]: choice }
        return
      }
      
      // Sync nose piece and frame colours
      if (this.pageMode === 'custom') {
        if (part === 'vcn' && 'vcf' in this.design) choice = this.design.vcf
        if (part === 'ven' && 'vef' in this.design) choice = this.design.vef
        if (part === 'an' && 'af' in this.design) choice = this.design.af
        
        if (part === 'vcf') {
          if ('vcn' in this.secondaryDesign) this.$set(this.secondaryDesign, 'vcn', choice)
          else this.$set(this.design, 'vcn', choice)
        }
        if (part === 'vef') {
          if ('ven' in this.secondaryDesign) this.$set(this.secondaryDesign, 'ven', choice)
          else this.$set(this.design, 'ven', choice)
        }
        if (part === 'af') {
          if ('an' in this.secondaryDesign) this.$set(this.secondaryDesign, 'an', choice)
          else this.$set(this.design, 'an', choice)
        }
      }

      this.$set(secondary ? this.secondaryDesign : this.design, part, choice)
    },
    changeLensTech (newLensSku) {
      this.lensTechSelected = true
      this.showLensTechWarning = false
      this.changeDesign(...(newLensSku || '').split('_'))
    },
    changeFrameType (newFrameType) {
      if (newFrameType === this.frameType) return

      // Determine what parts are changing
      let oldPart, newPart, framePart
      if (this.baseSku === 'vulcans') {
        oldPart = newFrameType === 'ff' ? 'vcn' : 'vcb'
        newPart = newFrameType === 'ff' ? 'vcb' : 'vcn'
        framePart = 'vcf'
      } else if (this.baseSku === 'velans') {
        oldPart = newFrameType === 'ff' ? 'ven' : 'veb'
        newPart = newFrameType === 'ff' ? 'veb' : 'ven'
        framePart = 'vef'
      } else if (this.baseSku === 'airas') {
        oldPart = newFrameType === 'bf' ? 'an' : 'ab'
        newPart = newFrameType === 'bf' ? 'ab' : 'an'
        framePart = 'af'
      }

      let newChoice
      if (this.pageMode !== 'conversionkit') {
        // If the new part is a nose piece then set it to the frame colour
        newChoice = this.design[framePart]
        if (['veb', 'vcb', 'an'].includes(newPart) && newPart in this.secondaryDesign) {
          newChoice = this.secondaryDesign[newPart]
        }
      } else if (newPart in this.previousChoices) {
        newChoice = this.previousChoices[newPart]
      }

      if (!newChoice) {
        const choices = Object.entries((this.productDetails[newPart] || {}).options).filter(
          ([_, details]) => details.stock
        )
        if (choices && choices.length) newChoice = choices[0][0].split('_')[1]
      }

      this.changeDesign(newPart, newChoice, false)
      if (oldPart in this.design) this.changeDesign(oldPart, this.design[oldPart], true)
      this.$delete(this.design, oldPart)
      this.$delete(this.secondaryDesign, newPart)
    },
    changeConversionKitState (state) {
      // Ensure there is a design ready
      if (state && Object.keys(this.secondaryDesign).length === 0) {
        this.setSecondaryDesign()
      }
      this.conversionKitEnabled = state

      // If we've just enabled the conversion kit then go to the first slide
      if (state) this.$refs.designerImages.goToSlide(0)
    },
    setSecondaryDesign () {
      const mapping = {
        vulcans: { frame: 'vcf', bottom: 'vcb', nose: 'vcn' },
        velans: { frame: 'vef', bottom: 'veb', nose: 'ven' },
        airas: { frame: 'af', bottom: 'ab', nose: 'an' }
      }

      const framePart = mapping[this.baseSku].frame
      const bottomPart = mapping[this.baseSku].bottom
      const nosePart = mapping[this.baseSku].nose
      const frameChoice = this.design[framePart] || this.design[bottomPart] || this.design[nosePart]

      // In FF mode then set the nose piece to match the frame
      if (bottomPart in this.design) this.changeDesign(nosePart, frameChoice, true)

      // In TF mode then set bottom piece to match frame colour if in stock
      if (nosePart in this.design) {
        let newChoice = Object.entries(this.productDetails[bottomPart].options).find(
          ([choice, choiceDetails]) => choice === `${bottomPart}_${frameChoice}` && choiceDetails.stock
        )
        if (!newChoice) newChoice = Object.entries(this.productDetails[bottomPart].options).find(
          ([choice, choiceDetails]) => this.getStockState(choice)
        )

        if (newChoice) {
          this.changeDesign(bottomPart, newChoice[0].split('_')[1], true)
        } else {
          console.log('Unable to determine part choice for conversion kit')
          this.$sentry.captureException(new Error('Unable to determine part choice for conversion kit'))
        }
      }
    },
    updateURL () {
      const params = { id: this.sku }

      if (this.conversionKitEnabled) params.ckid = this.secondarySku
      if (this.$route.query.preview) params.preview = 1

      const queryString = new URLSearchParams(params).toString()
      window.history.replaceState({}, '', `?${queryString}`)
    },
    async addToCart (additionalProducts = []) {
      if (this.allowLensTechFiltering) {
        if (!this.lensTechSelected) {
          // Lens tech hasn't been selected for a product where it's an option
          this.showLensTechWarning = true
          setTimeout(() => { this.showLensTechWarning = false }, 1500)
          return
        } else {
          // Track lens tech add to cart with LaunchDarkly
          this.$ld.track(`add-to-cart-${this.lensTech}`)
        }
      }

      if (this.secondarySku) additionalProducts.push(this.getSkuWithStockManagedParts(this.secondarySku))
      // if (this.casePromoActive && this.pageMode === 'custom') {
      //   additionalProducts.push({
      //     sierras: 'case-ct_capsule',
      //     classics3: 'case-ct_capsule',
      //     renegades: 'case-ct_capsule',
      //     vulcans: 'case-ct_pacecapsule',
      //     airas: 'case-ct_pacecapsule',
      //     velans: 'case-ct_pacecapsule',
      //     snipers: 'case-ct_revoltcapsule',
      //     vanguards: 'case-ct_revoltcapsule'
      //   }[this.baseSku] || 'case-ct_capsule')
      // }

      try {
        if (this.ecomProduct.type_id === 'bundle') await this.$refs.bundle.addToCart(additionalProducts.join(',') || null)
        else await this.$refs.simple.addToCart(additionalProducts.join(',') || null)
      } catch (error) {
        this.$sentry.captureException(error)
      }
    },
    showLightbox (event) {
      this.$refs.lightbox.show(event)
    },
    trackSKUChange () {
      this.$store.dispatch('session/TRACK', { event: 'VIEW_PRODUCT', sku: this.sku })
    },
    trackItemView () {
      const _learnq = window._learnq || []
      const item = {
        Name: this.plainTextProductName,
        SKU: this.sku,
        BaseSKU: this.baseSku,
        Price: this.price,
        Currency: this.storeCurrency,
        URL: window.location.href,
        ImageURL: `https://dynamic.sungod.co/?sku=${this.sku}`,
        SKUParts: this.sku.split('-')
      }
      _learnq.push(['track', 'Viewed Product', item])
      _learnq.push(['trackViewedItem', {
        Title: item.Name,
        ItemId: item.SKU,
        Price: item.Price,
        ImageUrl: item.ImageURL,
        Url: item.URL
      }])
    },
    handleCustomiserTabChange (partDetails) {
      if (!this.pageMode === 'parts') return

      const part = partDetails.skuPrefix

      // Update the design to a previously selected part if we've got one
      if (part in this.previousChoices) return this.changeDesign(part, this.previousChoices[part])

      // Otherwise select the first in stock part
      const options = (Object.fromEntries(this.sortedProductDetails || [])[part] || {}).options
      if (options && options.length) this.changeDesign(part, options[0][0].split('_')[1])
    },
    unsubscribe () {},
    onChannelError (error) {
      this.$sentry.captureException(error)
      console.error(error)
    },
    onUpdate (update) {
      this.$store.commit('product/STORE_PAGE_CONFIG', {
        skuPrefix: this.skuPrefix,
        query: this.gqlQuery,
        result: update.response.data.baseProduct
      })
    },
    showFirstHeroFeature () {
      if (this.$refs.heroFeatures) this.$refs.heroFeatures.goTo(0)
      this.$scrollTo('#features', { force: false, offset: -200 })
    }
  }
}
